/**
 * @generated SignedSource<<639af3a4a1f75f6980af2f6f80f66355>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type ProjectStageModalRemapImpactQuery$variables = {
  stageId: string;
  profile: PROJECT_STATUS;
};
export type ProjectStageModalRemapImpactQuery$data = {
  readonly viewer: {
    readonly company: {
      readonly projectStageRemapImpact: {
        readonly sage: {
          readonly activated: number | null;
          readonly created: number | null;
          readonly deactivated: number | null;
          readonly timeBlocked: boolean | null;
        } | null;
        readonly jira: {
          readonly stopSyncing: number | null;
          readonly startSyncing: number | null;
        } | null;
        readonly sageSyncOnSave: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type ProjectStageModalRemapImpactQuery = {
  variables: ProjectStageModalRemapImpactQuery$variables;
  response: ProjectStageModalRemapImpactQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profile"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stageId"
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "profile",
      "variableName": "profile"
    },
    {
      "kind": "Variable",
      "name": "stageId",
      "variableName": "stageId"
    }
  ],
  "concreteType": "ProjectStageRemapImpact",
  "kind": "LinkedField",
  "name": "projectStageRemapImpact",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectStageSageRemapImpact",
      "kind": "LinkedField",
      "name": "sage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deactivated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeBlocked",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectStageJiraRemapImpact",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stopSyncing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startSyncing",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageSyncOnSave",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectStageModalRemapImpactQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectStageModalRemapImpactQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4135c04268996edd42f15b55dff16588",
    "id": null,
    "metadata": {},
    "name": "ProjectStageModalRemapImpactQuery",
    "operationKind": "query",
    "text": "query ProjectStageModalRemapImpactQuery(\n  $stageId: ID!\n  $profile: PROJECT_STATUS!\n) {\n  viewer {\n    company {\n      projectStageRemapImpact(stageId: $stageId, profile: $profile) {\n        sage {\n          activated\n          created\n          deactivated\n          timeBlocked\n        }\n        jira {\n          stopSyncing\n          startSyncing\n        }\n        sageSyncOnSave\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aba1984f9fc1f7654fae95f9c84e1a6";

export default node;
